import React from "react";
import { useTranslation } from "react-i18next";
import getSymbolFromCurrency from 'currency-symbol-map';
import ButtonComponent from "./ButtonComponent";
import { getPathForNextPage } from "../lib/Utils";
import { INVOICE, USER_ACCOUNT } from "../assets/constants/PageList";
import { useHistory } from 'react-router-dom';

export default function UserLockersHistoryComponent({ locker }) {
  const { t } = useTranslation();
  const history = useHistory();

  const formatDateTime = (dateString) => {
    if (!dateString) return { date: "", time: "" };

    const date = new Date(dateString);
    if (isNaN(date)) return { date: "", time: "" };

    const datePart = date.toLocaleDateString('en-GB');
    const timePart = date.toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });

    return {
      date: datePart,
      time: timePart,
    };
  };

    const formatTimeToAmPm = (timeValue) => {
    if (!timeValue || typeof timeValue !== "string") return timeValue;

    const normalizedTime = timeValue.trim().toUpperCase();
    if (normalizedTime.includes("AM") || normalizedTime.includes("PM")) {
      return normalizedTime;
    }

    const [hoursString, minutesString = "00"] = normalizedTime.split(":");
    const hours = Number(hoursString);
    const minutes = Number(minutesString);

    if (Number.isNaN(hours) || Number.isNaN(minutes)) {
      return timeValue;
    }

    const suffix = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = String(minutes).padStart(2, "0");

    return `${formattedHours}:${formattedMinutes} ${suffix}`;
  };

  const checkIn = formatDateTime(locker?.reserve_start);
  const checkOut = formatDateTime(locker?.reserve_end);
   const downloadInvoice = () => {
          history.push({
              pathname: getPathForNextPage(USER_ACCOUNT, INVOICE),
              state: { lockerItem : locker },
          });
      };


  return (
    <div className="locker-card">
      <div className="top">
        <div className="title">{locker?.locker_bank_name}</div>
        <div className="status">{locker?.status}</div>
      </div>
      <div className="sub-text">
        {t("locker_size_locker_text", { size: locker?.door_size })}
        <span> {t("door_number_label", { doorNumber: locker?.door_number })}</span>
      </div>
      <div className="date-section">
        <div className="date-box">
          <span className="label">{t("check_in_label")}</span>
          <span className="value">{checkIn.date}</span>
          <span className="value">{formatTimeToAmPm(checkIn.time)}</span>
        </div>

        <div className="date-box">
          <span className="label">{t("check_out_label")}</span>
          <span className="value">{checkOut.date}</span>
          <span className="value">{formatTimeToAmPm(checkOut.time)}</span>
        </div>
      </div>
      <div className="total">
        {t("total_label")}: {getSymbolFromCurrency(locker?.currency)} {locker?.amount}
      </div>
      <hr />
      <ButtonComponent  title={t("invoice_Details")} handleClick={() => downloadInvoice()} />
    </div>
  );
}
